//import { forEach } from '@splidejs/splide/src/js/utils';
import Splide from 'splide';
import layzyload from 'layzyload';
document.addEventListener('DOMContentLoaded', function(){
	setCarousels();
});

let carArr=[];
const setCarousels =  () =>{
	const options = {
		type:'loop',
		mediaQuery: 'max',
		perPage: 1,
		focus: "center",
		perMove:1,
		arrows:false,
		pagination:false,
		waitForTransition:false,
		//gap:"3px",
		autoplay: false,
		interval: 6000,
		speed: 500,
		//padding: "15%",
		pauseOnFocus: false,
		updateOnMove: true,
		breakpoints: {
			767: {
				focus: "center",
				perPage: 1,
				gap:"1vw",
			}
		}
	}

	const setMountFunc = ( Splide, Components, options ) => {
		const mount=()=> {
			Splide.on( 'mounted', function () {
				const sldBt=Splide.root.querySelectorAll(".slidBt");
				const selUl=Splide.root.nextElementSibling;
				const sldCnt=Splide.length;
				let acv="active";
				
				for(let n=1;n<=sldCnt;n++){
					//selUl.insertAdjacentHTML('beforeend', '<li><a href="#" class="notHvr '+acv+'">'+n+'</a></li>');
					//acv="";
					
					const newLi = document.createElement("li");
					const newA = document.createElement("a");
					newA.textContent=n;
					newA.setAttribute("href", "#");
					newA.setAttribute("class", "notHvr "+acv);
					newLi.appendChild(newA);
					newA.addEventListener("click",(e)=>{
						e.preventDefault();
						Splide.go(n-1);
						/*
						const oldAct=selUl.querySelectorAll("li a.active");
						oldAct.forEach((o)=>{
							o.classList.remove("active");
						});
						e.target.classList.add("active");
						*/
					})
					selUl.appendChild(newLi);
					acv="";
				}
				
				sldBt.forEach((sb)=>{
					sb.addEventListener("click",(b)=>{
						b.preventDefault();
						if(sb.closest(".slidBt").classList.contains("btPr")){
							Splide.go('<');
						}else{
							Splide.go('>');
						}
					});
				})
			});
			Splide.on( 'move', function (e) {
				//console.log(e);
				const selUl=Splide.root.nextElementSibling;
				const atvBt = selUl.querySelectorAll("a")[e];
				const oldAct=selUl.querySelectorAll("li a.active");
				oldAct.forEach((o)=>{
					o.classList.remove("active");
				});
				atvBt.classList.add("active");
			});
			/*
			Splide.on( 'moved', function (e) {
			});
			*/
			/*
			Splide.on( 'move', function (e) {
				
			});
			*/
		}
		return {
			mount,
		};
	}

	//mainPhCal=new Splide('#topMainVis',options).mount({setMountFunc});
	const splids=document.querySelectorAll(".splide");
	let cnt=0;
	splids.forEach((s)=>{
		carArr[cnt]=new Splide(s,options).mount({setMountFunc});
		organizeImageLoaderCont(s.querySelectorAll("img"));
	});
}

/************動的書き出し画像のローダー設定 start************/
const organizeImageLoaderCont = (allImg) =>{
	//lazyload(document.querySelectorAll(targ));
	lazyload(allImg);
	//const allImg=document.querySelectorAll(targ);
	allImg.forEach((o)=>{
		o.insertAdjacentHTML('beforebegin','<div class="loaderWrap" ref="ldr"><div class="loader"></div></div>');
		o.onload=function(e){
			let loader=e.target.closest(".lazyWrap").querySelector(".loaderWrap");
			if(loader!=null){
				loader.remove();
			}
		}
	});
	
}
/************動的書き出し画像のローダー設定 end************/